import {BaseComponent, Collapse} from 'bootstrap';

/*
  Code inspired by https://css-tricks.com/in-page-filtered-search-with-vanilla-javascript/
 */
export default class FaqSearch {
  constructor(_faqSearchInput) {
    this._searchInput = _faqSearchInput;
    this._initialize();
  }

  _initialize() {
    let typingTimer;
    let typeInterval = 500;
    this._searchInput.addEventListener('keyup', () => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(this._performLiveSearch, typeInterval);
    });
  }

  _performLiveSearch() {
    const faqItems = document.querySelectorAll('.questions-collection .accordion-item');
    let searchInputQuery = document.getElementById('faq__search').value;
    // First, we hide all FAQ groups
    document.querySelectorAll('.bgr-faq-group').forEach(faqGroup => {
      faqGroup.classList.add('visually-hidden');
    });
    faqItems.forEach(faqItem => {
      // textContent is including hidden elements
      if (faqItem.textContent.toLowerCase()
        .includes(searchInputQuery.toLowerCase())) {
        // We show the group belonging to a found element
        faqItem.closest('.bgr-faq-group').classList.remove('visually-hidden');
        // We show the found element
        faqItem.classList.remove('visually-hidden');
      } else {
        faqItem.classList.add('visually-hidden');
      }
    });
  }
}
